import { useState } from 'react';
import Carousel from 'react-bootstrap/Carousel';
import Img1 from '../../images/ods/Yerta5.jpeg'
import Img2 from '../../images/ods/Indómita TOUR (2).jpg'
import Img3 from '../../images/ods/JM (146 de 147).jpg'
import Img4 from '../../images/ods/PXL_20230120_223419644.MP.jpg'
import './ods.css'

function ControlledCarousel() {
const [index, setIndex] = useState(0);

const handleSelect = (selectedIndex) => {
setIndex(selectedIndex);
};

return (
<Carousel activeIndex={index} onSelect={handleSelect}>
    <Carousel.Item className='caritem'>
        <img src={Img3} alt="" />
    {/* <ExampleCarouselImage text="First slide" /> */}
    </Carousel.Item>
    <Carousel.Item className='caritem'>
        <img src={Img1} alt="" />
    {/* <ExampleCarouselImage text="Second slide" /> */}
    </Carousel.Item>
    <Carousel.Item className='caritem'>
        <img src={Img2} alt="" />
    </Carousel.Item>
    <Carousel.Item className='caritem'>
        <img src={Img4} alt="" />
    </Carousel.Item>
</Carousel>
);
}

export default ControlledCarousel;